import { Locale, type LocalizedString } from "../Locale.js";

export const weddingsPathMap = {
	[Locale.cs]: "svatebni-dorty" as const,
} satisfies LocalizedString;

export const weddingsCakeEnquiryPathMap = {
	[Locale.cs]: "poptavka-svatebniho-dortu" as const,
} satisfies LocalizedString;
